import { DefaultItem, FileItem } from "@directus/sdk";
import ExpandCircleDownOutlinedIcon from "@mui/icons-material/ExpandCircleDownOutlined";
import {
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@mui/material";
import React, { ReactElement, useEffect, useState } from "react";

import { Asset } from "../../generated/gql/graphql";
import Tags from "../../pages/detail-page/parts/tags";
import Title from "../../pages/detail-page/parts/title";
import { useDirectus } from "../../providers/DirectusProvider";

type Props = {
  asset: Asset;
};

export default function AssetMetadata(props: Props): ReactElement {
  const { asset } = props;

  const { directus } = useDirectus();
  const [filedata, setFiledata] = useState<
    DefaultItem<FileItem<unknown>> | undefined
  >();
  const [metadata, setMetadata] = useState<any[]>();

  async function loadFileData(): Promise<void> {
    try {
      if (asset.image) {
        const result = await directus?.files.readOne(asset.image);
        setFiledata(result ?? undefined);
        if (result && result.metadata) {
          setMetadata(getMetadataCollection(result.metadata));
        }
      }
    } catch (err) {
      console.error(err);
    }
  }

  useEffect(() => {
    loadFileData();
  }, [asset]);

  const [metadataSwitcher, setMetadataSwitcher] = useState(false);

  function getMetadataCollection(values: unknown): unknown[] {
    const rowsArray = [];

    if (values) {
      for (const key in values) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const subObj = values[key];
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        if (typeof values[key] == "object") {
          rowsArray.push({ caption: true, name: key });
        }

        for (const subKey in subObj) {
          rowsArray.push({
            caprion: false,
            name: `${subKey}: ${subObj[subKey]}`,
          });
        }
      }
    }

    return rowsArray;
  }

  return (
    <div>
      {metadata && (
        <div className="text-16 mb-[40px]">
          <Title>
            Meta data
            <IconButton
              onClick={() => setMetadataSwitcher(!metadataSwitcher)}
              className="ml-5 mt-[-5px]"
              size="small"
            >
              {metadataSwitcher ? (
                <ExpandCircleDownOutlinedIcon />
              ) : (
                <ExpandCircleDownOutlinedIcon className="-rotate-90" />
              )}
            </IconButton>
          </Title>
          <TableContainer
            style={{ display: metadataSwitcher ? "block" : "none" }}
            className="w-full"
            component={Paper}
          >
            <Table aria-label="caption table" size="small">
              <TableBody>
                {metadata.map((o: any) => (
                  <TableRow key={o.name}>
                    <TableCell
                      className={
                        o.caption ? "capitalize bg-slate-100" : "pl-[30px]"
                      }
                      component={o.caption ? "th" : undefined}
                    >
                      {o.name}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      )}
      {filedata?.tags && <Tags tags={filedata.tags} />}
    </div>
  );
}
